/**
 * Luggage size guide PDP drawer (`iam-aside#LuggageSizeGuideDrawer`).
 *
 * Opens via the in-page trigger: a control with `data-aside-target="LuggageSizeGuideDrawer"`
 * (see `luggage-size-guide.liquid`), which the shared `iam-aside` component wires on click.
 */
import 'snippets/_containers/aside/aside';
import './_luggage-size-guide.scss';